export default "__VITE_ASSET__CE84WMpy__"